import OrbisLogoIcon from 'static/images/orbis-logo.svg';
import CompareIcon from 'static/images/map-tools/icon-compare.svg';
import MenuIcon from 'static/images/map-tools/icon-menu.svg';
import LinkIcon from 'static/images/map-tools/icon-link.svg';
import PrintIcon from 'static/images/map-tools/icon-print.svg';
import DownloadIcon from 'static/images/map-tools/icon-download.svg';
import LayersIcon from 'static/images/map-tools/icon-layers.svg';
import PlayIcon from 'static/images/icons/icon-play.svg';
import PdfIcon from 'static/images/icons/icon-pdf.svg';
import RulerIcon from 'static/images/map-tools/icon-ruler.svg';
import PointIcon from 'static/images/map-tools/measurements/icon-point.svg';
import RadiusIcon from 'static/images/map-tools/measurements/icon-radius.svg';
import AreaIcon from 'static/images/map-tools/measurements/icon-area.svg';
import DistanceIcon from 'static/images/map-tools/measurements/icon-distance.svg';
import LangRuIcon from 'static/images/lang-ru.svg';
import LangEnIcon from 'static/images/lang-en.svg';
import MagnifyGlassPlusIcon from 'static/images/magnify-glass-plus.svg';
import StarIcon from 'static/images/star.svg';
import QuestionMarkIcon from 'static/images/question-mark.svg';
import CloseIcon from 'static/images/close.svg';
import SmallCloseIcon from 'static/images/close-small.svg';
import CameraIcon from 'static/images/camera.svg';
import InfoIcon from 'static/images/info.svg';
import LogoutIcon from 'static/images/logout.svg';
import CoaIcon from 'static/images/coa.svg';
import Coa2Icon from 'static/images/coa2.svg';
import Coa3Icon from 'static/images/coa3.svg';
import GarbageBinIcon from 'static/images/garbage-bin.svg';
import GarbageBin2Icon from 'static/images/garbage-bin-2.svg';
import ArrowLeftIcon from 'static/images/icon-arrow-left.svg';
import ArrowRightIcon from 'static/images/icon-arrow-right.svg';
import IconArrowLite from 'static/images/icon-arrow-lite.svg';
import ExcelIcon from 'static/images/excel.svg';
import MagnifyGlassIcon from 'static/images/search-icon.svg';
import ThickArrowRightIcon from 'static/images/thick-arrow-right.svg';
import PenIcon from 'static/images/pen.svg';
import QuadMenuIcon from 'static/images/quad-menu.svg';
import ListIcon from 'static/images/icon-list.svg';
import NoteIcon from 'static/images/note.svg';
import TocIcon from 'static/images/icon-toc.svg';
import ColoredRuFlagIcon from 'static/images/colored-ru-flag.svg';
import ColoredEnFlagIcon from 'static/images/colored-en-flag.svg';
import BlackAndWhiteLogoIcon from 'static/images/bnw-logo.svg';
import MapIcon from 'static/images/map-icon.svg';
import RotateDeviceIcon from 'static/images/rotate.svg';
import SettingsIcon from 'static/images/settings.svg';
import WarningIcon from 'static/images/icons/icon-warning.svg';
import IconDocIcon from 'static/images/icon-doc-gray.svg';

/* Иконки типов файлов */
import DefaultFileIcon from 'static/images/files/def.svg';
import DOCFileIcon from 'static/images/files/doc.svg';
import PDFFileIcon from 'static/images/files/pdf.svg';
import PPTFileIcon from 'static/images/files/ppt.svg';
import RARFileIcon from 'static/images/files/rar.svg';
import RTFFileIcon from 'static/images/files/rtf.svg';
import XLSFileIcon from 'static/images/files/xls.svg';
import ZIPFileIcon from 'static/images/files/zip.svg';

import { createSvgIcon } from './create-svg-icon';

export namespace Pictures {
    export const OrbisLogo = createSvgIcon(OrbisLogoIcon);
}

export namespace FileExtentionIcons {
    export const Default = createSvgIcon(DefaultFileIcon);
    export const DOC = createSvgIcon(DOCFileIcon);
    export const PDF = createSvgIcon(PDFFileIcon);
    export const PPT = createSvgIcon(PPTFileIcon);
    export const RAR = createSvgIcon(RARFileIcon);
    export const RTF = createSvgIcon(RTFFileIcon);
    export const XLS = createSvgIcon(XLSFileIcon);
    export const ZIP = createSvgIcon(ZIPFileIcon);
}

export namespace Icons {
    export const IconCompare = createSvgIcon(CompareIcon);
    export const IconMenu = createSvgIcon(MenuIcon, { viewBox: '0 0 17 17' });
    export const IconLink = createSvgIcon(LinkIcon);
    export const IconPrint = createSvgIcon(PrintIcon);
    export const IconDownload = createSvgIcon(DownloadIcon);
    export const IconLayers = createSvgIcon(LayersIcon);
    export const IconPlay = createSvgIcon(PlayIcon);
    export const IconPdf = createSvgIcon(PdfIcon);
    export const IconRuler = createSvgIcon(RulerIcon);
    export const IconPoint = createSvgIcon(PointIcon);
    export const IconRadius = createSvgIcon(RadiusIcon);
    export const IconArea = createSvgIcon(AreaIcon);
    export const IconDistance = createSvgIcon(DistanceIcon);
    export const IconQuestionMark = createSvgIcon(QuestionMarkIcon);
    export const IconLangRu = createSvgIcon(LangRuIcon);
    export const IconLangEn = createSvgIcon(LangEnIcon);
    export const IconMagnifyGlassPlus = createSvgIcon(MagnifyGlassPlusIcon);
    export const IconStar = createSvgIcon(StarIcon, { viewBox: '0 0 20 20' });
    export const IconClose = createSvgIcon(CloseIcon);
    export const IconCloseSmall = createSvgIcon(SmallCloseIcon);
    export const IconCamera = createSvgIcon(CameraIcon);
    export const IconInfo = createSvgIcon(InfoIcon);
    export const IconLogout = createSvgIcon(LogoutIcon);
    export const IconCoa = createSvgIcon(CoaIcon, { width: '31px', height: '36px', viewBox: '0 0 795.3 907.87' });
    export const IconCoa2 = createSvgIcon(Coa2Icon, { viewBox: '0 0 76 76' });
    export const IconCoa3 = createSvgIcon(Coa3Icon, { width: '31px', height: '36px', viewBox: '0 0 48 60' });
    export const IconGarbageBin = createSvgIcon(GarbageBinIcon);
    export const IconGarbageBin2 = createSvgIcon(GarbageBin2Icon);
    export const IconArrowLeft = createSvgIcon(ArrowLeftIcon);
    export const IconArrowRight = createSvgIcon(ArrowRightIcon);
    export const IconExcel = createSvgIcon(ExcelIcon);
    export const IconMagnifyGlass = createSvgIcon(MagnifyGlassIcon, { viewBox: '0 0 15 15' });
    export const IconThickArrowRight = createSvgIcon(ThickArrowRightIcon);
    export const IconPen = createSvgIcon(PenIcon);
    export const IconQuadMenu = createSvgIcon(QuadMenuIcon);
    export const IconList = createSvgIcon(ListIcon);
    export const IconNote = createSvgIcon(NoteIcon);
    export const IconToc = createSvgIcon(TocIcon);
    export const IconColoredRuFlag = createSvgIcon(ColoredRuFlagIcon, { viewBox: '0 0 20 15' });
    export const IconColoredEnFlag = createSvgIcon(ColoredEnFlagIcon, { viewBox: '0 0 20 15' });
    export const IconMap = createSvgIcon(MapIcon);
    export const IconRotateDevice = createSvgIcon(RotateDeviceIcon);
    export const BlackAndWhiteLogo = createSvgIcon(BlackAndWhiteLogoIcon);
    export const ArrowLiteIcon = createSvgIcon(IconArrowLite);
    export const Settings = createSvgIcon(SettingsIcon, { viewBox: '0 0 24 24' });
    export const Warning = createSvgIcon(WarningIcon, { viewBox: '0 0 20 20' });
    export const IconDoc = createSvgIcon(IconDocIcon, { viewBox: '0 0 20 20' });
}
